var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"fs18 flex aic"},[_c('i'),_c('span',{staticClass:"ml10"},[_vm._v(_vm._s(_vm.prefix)+_vm._s(_vm.title))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }